import React, { useContext, useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import TabsContext from '../context/tabs-context';
import Tab from '../components/tab';

const TabContainer = ({ disabled = false, label, tabId }) => {
  const { activeTabId, onTabChange, activeTabManager, noBackground, appearance } =
    useContext(TabsContext);
  const tabRef = useRef(null);
  const isActive = tabId === activeTabId;

  const handleClick = useCallback(() => {
    onTabChange(tabId);
  }, [onTabChange, tabId]);

  useEffect(() => {
    if (isActive) {
      activeTabManager.publish(tabRef);
    }
  }, [activeTabManager, isActive]);

  return (
    <Tab
      ref={tabRef}
      disabled={disabled}
      label={label}
      onClick={handleClick}
      active={isActive}
      noBackground={noBackground}
      appearance={appearance}
    />
  );
};

TabContainer.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  tabId: PropTypes.string.isRequired,
};

export default TabContainer;
